<section>
  <ness-find-person [excludePersons]="excludePersons"></ness-find-person>
  <ness-find-person-results (notifySelectedPeople)="notifySelectedPeople.emit($event)" [suppressEdit]="suppressEdit"></ness-find-person-results>
</section>
